"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CrudService_1 = __importDefault(require("../../Core/CrudService"));
var cached_item_1 = require("../../utils/cached-item");
var entityName = 'rule-service/workflow';
var baseRoute = "/".concat(entityName);
var WorkflowsService = /** @class */ (function () {
    function WorkflowsService(session) {
        this.service = new CrudService_1.default(session, entityName);
        this.manualTriggersCache = new cached_item_1.CachedItem();
    }
    WorkflowsService.prototype.loadAll = function (commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.getAll(undefined, commonOptions)];
            });
        });
    };
    WorkflowsService.prototype.delete = function (id, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.manualTriggersCache.invalidate();
                return [2 /*return*/, this.service.delete(id, undefined, commonOptions)];
            });
        });
    };
    WorkflowsService.prototype.update = function (id, workflow, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.manualTriggersCache.invalidate();
                return [2 /*return*/, this.service.update(id, workflow, commonOptions)];
            });
        });
    };
    WorkflowsService.prototype.patch = function (id, workflow, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.manualTriggersCache.invalidate();
                return [2 /*return*/, this.service.patch(id, workflow, commonOptions)];
            });
        });
    };
    WorkflowsService.prototype.create = function (workflow, commonOptions) {
        if (commonOptions === void 0) { commonOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.manualTriggersCache.invalidate();
                return [2 /*return*/, this.service.create(workflow, commonOptions)];
            });
        });
    };
    WorkflowsService.prototype.duplicate = function (workflowId, commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .post("".concat(baseRoute, "/{:id}/duplicate"))
                        .withRouteParams({ id: workflowId })
                        .setException("failed to duplicate workflow ".concat(workflowId))
                        .withCommonOptions(commonOptions)
                        .invoke()];
            });
        });
    };
    WorkflowsService.prototype.getTemplates = function (commonOptions) {
        return this.service.routeGenerator
            .get("".concat(baseRoute, "/templates"))
            .setException('failed to get workflow templates')
            .withCommonOptions(commonOptions)
            .invoke();
    };
    WorkflowsService.prototype.manualTrigger = function (workflowId, triggerRequest, commonOptions) {
        return this.service.routeGenerator
            .post("".concat(baseRoute, "/v3/manual/{:workflow_id}"))
            .withRouteParams({ workflow_id: workflowId })
            .withPayload(triggerRequest)
            .setException("failed to manual trigger: ".concat(workflowId))
            .withCommonOptions(commonOptions)
            .invoke();
    };
    WorkflowsService.prototype.getManualTriggers = function (commonOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.manualTriggersCache.isValid()) return [3 /*break*/, 2];
                        _b = (_a = this.manualTriggersCache).set;
                        return [4 /*yield*/, this.service.routeGenerator
                                .get("".concat(baseRoute, "/v4/manual"))
                                .setException('failed to get manual triggers configuration')
                                .withCommonOptions(commonOptions)
                                .invoke()];
                    case 1:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 2;
                    case 2: return [2 /*return*/, this.manualTriggersCache.get()];
                }
            });
        });
    };
    return WorkflowsService;
}());
exports.default = WorkflowsService;
//# sourceMappingURL=workflows-service.js.map